import React from 'react';
import { motion } from 'framer-motion';
import './Skills.css';
const skillCategories = [
  {
        title: 'Business & Leadership',
        icon: '◆',
        color: 'var(--color-accent)',
        skills: ['Strategic Planning', 'Brand Building', 'Corporate Governance', 'Business Development'],
  },
  {
        title: 'Textile & Apparel',
        icon: '◇',
        color: 'var(--color-accent-purple)',
        skills: ['Textile Manufacturing', 'Brand Licensing', 'Production Innovation', 'Supply Chain'],
  },
  {
        title: 'Philanthropy & Social Impact',
        icon: '♥',
        color: 'var(--color-accent)',
        skills: ['Foundation Management', 'Children\'s Welfare', 'Community Outreach', 'Volunteer Coordination'],
  },
  {
        title: 'International Business',
        icon: '◈',
        color: 'var(--color-accent-purple)',
        skills: ['Cross-Border Operations', 'Partnership Development', 'Market Expansion', 'Family Enterprise'],
  },
  ];
function Skills() {
    return (
          <section className="skills section-padding" id="skills">
            <div className="container">
              <motion.div
            className="skills__header"
            initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">EXPERTISE</span>
          <h2 className="section-title">
                      Areas of<br />
                      <span className="text-gradient">knowledge & impact</span>
          </h2>
          </motion.div>
<div className="skills__grid">
        {skillCategories.map((category, index) => (
                      <motion.div
                                           className="skills__card"
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <div className="skills__card-icon" style={{ color: category.color }}>
{category.icon}
</div>
              <h3 className="skills__card-title">{category.title}</h3>
              <div className="skills__card-list">
{category.skills.map((skill, i) => (
                    <span className="skills__card-item" key={i}>{skill}</span>
                ))}
                  </div>
                  </motion.div>
          ))}
            </div>
            </div>
            </section>
  );
}
export default Skills;
